import React, { useRef, useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import useWindowRezise from './hooks/useWindowRezise';

const responsive = {
    desktop: {
        breakpoint: { max: 100000, min: 1024 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
        partialVisibilityGutter: 290
    },
    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
        partialVisibilityGutter: 80
    },
    mobile: {
        breakpoint: { max: 767, min: 0 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
        partialVisibilityGutter: 0
    },
};
const ImageSlider = ({ values }) => {
    const refPlayPause = useRef(null);
    const refVideo = useRef(null);

    let video;
    let playPause;

    const changeButtonState = (type) => {
        if (type == 'playpause') {
            if (video.paused || video.ended) {
                playPause.classList.remove(
                    'slider__video-item-play-pause--playing'
                );
            } else {
                playPause.classList.add(
                    'slider__video-item-play-pause--playing'
                );
            }
        }
    };
    const [refAquired, setRefAquired] = useState(false);
    const [isMobileWidth, setIsMobileWidth] = useState(false);
    const { width } = useWindowRezise();

    useEffect(() => {
        setRefAquired(true);
    }, []);
    useEffect(() => {
        video = refVideo.current;
        playPause = refPlayPause.current;
        const mobile = width < responsive.tablet.breakpoint.min;

        setIsMobileWidth(mobile);
        if (video && width >= 768) video.play();
    }, [refAquired]);
    const getPos = (e) => {
        const bounds = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - bounds.left;
        const y = e.clientY - bounds.top;

        e.target.style.top =
            '-' +
            (y * (e.target.offsetHeight - e.currentTarget.offsetHeight)) /
            e.currentTarget.offsetHeight +
            'px';
        e.target.style.left =
            '-' +
            (x * (e.target.offsetWidth - e.currentTarget.offsetWidth)) /
            e.currentTarget.offsetWidth +
            'px';
    };

    return width >= 768 ? null : (
        <Carousel
            swipeable={true}
            draggable={false}
            showDots={false}
            responsive={responsive}
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-8-px"
            keyBoardControl={true}
            partialVisible={values.length > 1}
            beforeChange={(nextSlide, { currentSlide, onMove }) => {
                if (video) {
                    if (width < responsive.mobile.breakpoint.max) {
                        if (
                            currentSlide === 1 &&
                            (nextSlide === 0 || nextSlide === 2)
                        ) {
                            video.pause();
                        }
                    } else {
                        if (nextSlide === 2 && currentSlide < 2) video.pause();
                        else if (currentSlide === 2 && nextSlide < 2)
                            video.play();
                    }
                }
            }}
        >
            {values.map((value, index) =>
                value.image ? (
                    <div
                        onMouseMove={(e) => getPos(e)}
                        onMouseOut={(e) => {
                            e.currentTarget.classList.remove(
                                'slider__item--hover'
                            );
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.classList.add(
                                'slider__item--hover'
                            );
                        }}
                        className="slider__item"
                        key={`figure${index}`}
                    >
                        <a href={value.url}>                             
                            <div dangerouslySetInnerHTML={{
                                __html: value.image,
                            }}></div>                          
                        </a>
                    </div>
                ) : (
                    <div className="slider__video-item" key={`figure${index}`}>
                        <figure className="slider__video-item-container">
                            <video
                                onPlay={() => changeButtonState('playpause')}
                                onPause={() => changeButtonState('playpause')}
                                ref={refVideo}
                                loop
                                muted
                                playsInline
                                preload="metadata"
                            >
                                <source
                                    src={`${value.video}#t=0.001`}
                                    type="video/mp4"
                                />
                            </video>
                            <div className="slider__video-item-controls">
                                <button
                                    ref={refPlayPause}
                                    className="slider__video-item-play-pause"
                                    type="button"
                                    onClick={() => {
                                        if (video.paused || video.ended)
                                            video.play();
                                        else video.pause();
                                    }}
                                ></button>
                            </div>
                        </figure>
                    </div>
                )
            )}
        </Carousel>
    );
};
export default ImageSlider;
